<template>
	<div class="container">
		<div v-if="news.list == false" style="heght: 70vh">
			<div class="iv2-news__items-null row clearfix">
				<div class="column full">
					<div style="padding: 2rem 0;">
						<h5 class="size-24" style="text-align: center;">表示する記事はありません。</h5>
						<p style="text-align: center;">現在、投稿されている記事はありません。</p>
					</div>
					<div class="row clearfix">
						<div class="column full" style="margin: 0 auto;">
							<div style="text-align: center;">
								<span>
									<router-link
										to
										class="theme__main-btn is-btn is-btn-ghost2 is-upper"
										style="border: 0; letter-spacing: 2px; max-width: 100%; width: 334px; padding-top: 15px; padding-bottom: 15px;"
									>トップページに戻る</router-link>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="row clearfix">
				<div class="column full">
					<div class="spacer height-60"></div>
				</div>
			</div>
			<div class="iv2-news-archive theme-c__news-category pl-2 pr-2">
				<div class="row">
					<div class="iv2-news-category d-none d-xl-inline-block col-xl-9">
						<label
							v-for="category in news.categories"
							:key="category.id"
							:for="'sort_' + category.id"
							@click="change(category.id)"
							:class="{'active': isActive === category.id}"
							class="iv2-news-category__button"
						>
							<input
								type="radio"
								:value="category.id"
								:id="'sort_' + category.id"
								v-model="filterCategory"
								name="category"
								class="iv2-news-category__button-input"
								autocomplete="off"
							/>
							{{ category.name }}
						</label>
					</div>
					<div
						class="iv2-news-category__mobile col-12 d-flex d-xl-none align-items-center justify-content-center"
					>
						<select class="iv2-news-category__select w-100 m-3" name="archive" v-model="filterCategory">
							<option
								v-for="category in news.categories"
								:key="category.id"
								:value="category.id"
							>{{category.name}}</option>
						</select>
					</div>
					<div class="iv2-news-season col-xl-3 d-flex align-items-center justify-content-center">
						<select
							class="iv2-news-season__select m-1 d-none d-xl-block"
							name="archive"
							v-model="filterArchive"
						>
							<option
								v-for="archive in archives"
								:key="archive.year"
								:value="archive.year"
							>{{archive.name}}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="row clearfix">
				<div class="column full">
					<div class="spacer height-60"></div>
				</div>
			</div>
			<div class="row clearfix">
				<div v-for="item in eventAction" :key="item.id" class="iv2-news-item mb-5 col-md-6 col-xl-4">
					<router-link :to="'/news/' + item.id" class="iv2-news-item__link">
						<div class="iv2-news-item__img fit-img">
							<img :src="item.thumbnail" class="m-0" />
						</div>

						<div class="iv2-news-item__data mt-4">
							<div class="row">
								<div class="col-6 pr-0">
									<small class="iv2-news-item__date">{{ item.created | moment }}</small>
									<small
										v-if="isAfter(setDatetime(item.created), end)"
										class="iv2-news-item__new ml-1"
									>{{ new_label }}</small>
								</div>
								<div class="col-6" style="padding-top: 3px;">
									<small class="iv2-news-item__label d-block">{{ item.category_name }}</small>
								</div>
							</div>
						</div>
						<h3 class="iv2-news-item__title">{{ item.title }}</h3>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	props: ["news"],
	data() {
		return {
			new_label: "NEW",
			archives: [
				{ year: 9999, name: "年別アーカイブ" },
				{ year: 2020, name: "2020年" },
				{ year: 2019, name: "2019年" }
			],
			filterCategory: 999,
			isActive: 999,
			filterArchive: 9999,
			start: "",
			end: moment().format()
		};
	},
	computed: {
		eventAction: function() {
			let list = this.news.list.slice();
			if (this.filterCategory !== 999) {
				list = list.filter(element => {
					return element.category_id === this.filterCategory;
				});
			} else if (this.filterArchive !== 9999) {
				list = list.filter(element => {
					return element.created.startsWith(this.filterArchive);
				});
			} else if (
				this.filterCategory !== 999 &&
				this.filterArchive !== 9999
			) {
				list = list.filter(element => {
					return (
						element.category_id === this.filterCategory &&
						element.created.startsWith(this.filterArchive)
					);
				});
			}
			return list;
		}
	},
	methods: {
		change: function(num) {
			this.isActive = num;
		},

		isAfter: function(start, end) {
			return moment(start).isAfter(end);
		},

		setDatetime: function(start) {
			return moment(start)
				.add(14, "days")
				.format();
		}
	},
	watch: {
		$route: function(to, from) {
			if (to.path !== from.path) {
				this.radioSelect = false;
			}
		}
	},
	filters: {
		moment: function(created) {
			return moment(created).format("YYYY年MM月DD日");
		}
	}
};
</script>

<style lang="scss">
.iv2-news__items-null {
	padding: 8rem 0;
}

.iv2-news-item .iv2-news-item__link {
	display: block;
	text-decoration: none;

	&:hover .iv2-news-item__img {
		opacity: 0.7;
	}

	.iv2-news-item__img {
		height: 200px;
		-webkit-transition: 0.3s;
		transition: 0.3s;
	}

	.iv2-news-item__title {
		font-size: 1.1rem;
		font-weight: bold;
	}

	.iv2-news-item__new {
		color: #ff0a0a;
		border: 1px solid;
		padding: 6px 10px;
	}

	.iv2-news-item__label {
		width: 100%;
		text-align: center;
		border: 1px solid;
	}
}

/* PC */
@media (min-width: 1200px) {
	.iv2-news-archive {
		.iv2-news-season__select {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			padding-left: 32px;
			border-radius: 0;
			border: 1px solid #000000;
			width: 180px;
			background-color: #ffffff;

			&::-ms-expand {
				display: none;
			}
		}

		.iv2-news-season:before {
			content: "";
			left: 55px;
			display: block;
			position: absolute;
			z-index: 3;
			width: 7px;
			height: 7px;
			border-top: 2px solid #000;
			border-right: 2px solid #000;
			-webkit-transform: rotate(135deg);
			transform: rotate(135deg);
		}
		.iv2-news-category__button {
			display: inline-block;
			background-color: transparent;
			border: none;
			border-bottom: 3px solid transparent;
			margin: 0 15px;
			padding: 15px 0;
			-webkit-transition: 0.2s;
			transition: 0.2s;
			cursor: pointer;
			&:hover,
			&.active {
				border-bottom: 3px solid;
			}
			.iv2-news-category__button-input {
				display: none;
				:checked {
					.iv2-news-category__button {
						border-bottom: 3px solid;
					}
				}
			}
			.iv2-news-category__button-name {
				margin: auto;
			}
		}
	}
}
/* TABLET or SP */
@media (max-width: 1199px) {
	.iv2-news-archive {
		padding: 10px;
		background-color: transparent !important;

		.iv2-news-category__select {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			border-radius: 0;
			border: 1px solid #000;
			padding: 0 10px;
			background-color: #fff;
		}

		.iv2-news-category__mobile:before {
			content: "";
			right: 45px;
			display: block;
			position: absolute;
			z-index: 10;
			width: 7px;
			height: 7px;
			border-top: 2px solid #000;
			border-right: 2px solid #000;
			-webkit-transform: rotate(135deg);
			transform: rotate(135deg);
		}
	}
}
/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-news__items-null {
		padding: 15rem 0;
	}
}
/* SP Only */
@media (max-width: 767px) {
}
</style>